import React, { useEffect, useState } from "react";
import TailwindTable from "../../../tailwind-ui/components/TailwindTable";
import TailwindPagination from "../../../tailwind-ui/components/TailwindPagination"; // make sure this path is correct

const TokenLogsActivity = ({ logs = [] }) => {
  const columns = [
    "Time",
    "Verb",
    "Namespace",
    "Resource",
    "Resource Type",
    "Status",
    "Reason",
    "Pods",
    "Source IPs",
    "Token",
  ];

  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);

  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      const filtered = logs.filter((log) =>
        Object.values(log)
          .flatMap((value) =>
            Array.isArray(value)
              ? value.map(String)
              : typeof value === "object" && value !== null
                ? Object.values(value).map(String)
                : [String(value)],
          )
          .some((val) => val.toLowerCase().includes(searchValue.toLowerCase())),
      );
      setFilteredData(filtered);
      setCurrentPage(1);
      setLoading(false);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchValue, logs]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    setPaginatedData(filteredData.slice(startIndex, endIndex));
  }, [filteredData, currentPage]);

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const renderCell = (item, colIndex) => {
    switch (colIndex) {
      case 0:
        return (
          <div className="text-base text-gray-800 whitespace-nowrap">
            {new Date(item.timeGenerated).toLocaleString("en-GB")}
          </div>
        );
      case 1:
        return <div className="capitalize">{item.verb}</div>;
      case 2:
        return <div>{item.namespace}</div>;
      case 3:
        return <div>{item.resourceName}</div>;
      case 4:
        return (
          <div className="text-base text-gray-600">{item.resourceType}</div>
        );
      case 5:
        return (
          <div className="font-semibold text-green-700">{item.statusCode}</div>
        );
      case 6:
        return (
          <div className="text-gray-700 break-words max-w-base">
            {item.reason}
          </div>
        );
      case 7:
        return (
          <div>
            {item.pods && item.pods.length > 0 ? (
              item.pods.map((p, i) => (
                <div
                  key={i}
                  className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded  inline-block m-0.5"
                >
                  {p}
                </div>
              ))
            ) : (
              <div className="text-gray-400">-</div>
            )}
          </div>
        );
      case 8:
        return (
          <div className="flex flex-col gap-1">
            {item.sourceIPs.map((ip, idx) => (
              <div
                key={idx}
                className="bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded  w-fit"
              >
                {ip}
              </div>
            ))}
          </div>
        );
      case 9:
        return (
          <div className="bg-gray-100 text-gray-800 px-2 py-0.5 rounded ">
            {item.customTokenName || "-"}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="space-y-4">
      <TailwindTable
        columns={columns}
        data={paginatedData}
        renderCell={renderCell}
        needLoading={loading}
        isTableFilterNeeded={true}
        tableSearchAction={setSearchValue}
        tableSearchValue={searchValue}
      />

      <div className="flex justify-end mt-4">
        <TailwindPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default TokenLogsActivity;
